import identity from "lodash/fp/identity";

class BulkcreditsPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default BulkcreditsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bulkcredits/bulkcredits.transforms.js